import { __decorate } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import 'react-quill/dist/quill.snow.css';
import isEqual from 'lodash/isEqual';
import noop from 'lodash/noop';
import { FormField } from '../field/FormField';
import autobind from '../_util/autobind';
import BaseEditor from './BaseEditor';
import RichTextViewer from './RichTextViewer';
import { randomWord } from './utils';
import { RichTextMode, RichTextToolbarType } from './enum';
const defaultRichTextOptions = {
    theme: 'snow',
};
let RichText = class RichText extends FormField {
    constructor() {
        super(...arguments);
        this.toolbarId = randomWord(false, 32, 64);
        this.rtOptions = this.getRichTextOptions();
    }
    getRichTextOptions(options = this.props.options) {
        if (options) {
            if (options.modules && options.modules.imageDropAndPaste !== false) {
                options.modules.imageDropAndPaste = true;
            }
        }
        else {
            options = {
                modules: {
                    toolbar: {
                        container: `#${this.toolbarId}`,
                    },
                    imageDropAndPaste: true,
                },
            };
        }
        return { ...defaultRichTextOptions, ...options };
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'defaultValue',
            'value',
        ]);
    }
    getOtherProps() {
        const otherProps = super.getOtherProps();
        delete otherProps.disabled;
        return otherProps;
    }
    handleChange(value) {
        this.setValue(value);
    }
    // 禁用与只读表现一致
    // @autobind
    // setDisabled(disabled) {
    //   if(this.element && this.element.editor) {
    //     this.element.editor.getEditor().enable(!disabled);
    //   }
    // }
    componentWillReceiveProps(nextProps, nextContext) {
        const { options } = nextProps;
        if (!isEqual(options, this.props.options)) {
            this.rtOptions = this.getRichTextOptions(options);
        }
        super.componentWillReceiveProps(nextProps, nextContext);
    }
    handleRichTextBlur(props) {
        const { onBlur = noop } = this.props;
        onBlur(props);
    }
    renderWrapper() {
        const { defaultValue, dataSet } = this.props;
        this.rtOptions.readOnly = this.disabled || this.readOnly;
        const deltaOps = this.getValue() || defaultValue;
        return (React.createElement("div", Object.assign({}, this.getWrapperProps()),
            React.createElement(BaseEditor, Object.assign({}, this.getOtherProps(), this.rtOptions, { toolbarId: this.toolbarId, value: toJS(deltaOps), dataSet: dataSet, onBlur: this.handleRichTextBlur })),
            this.renderFloatLabel()));
    }
};
RichText.displayName = 'RichText';
RichText.RichTextViewer = RichTextViewer;
RichText.propTypes = {
    options: PropTypes.object,
    mode: PropTypes.oneOf([RichTextMode.editor, RichTextMode.preview]),
    toolbar: PropTypes.oneOfType([
        PropTypes.oneOf([
            RichTextToolbarType.none,
            RichTextToolbarType.normal,
        ]),
        PropTypes.func,
    ]),
    ...FormField.propTypes,
};
RichText.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'rich-text',
    autoFocus: false,
    mode: 'editor',
    toolbar: RichTextToolbarType.normal,
};
__decorate([
    autobind
], RichText.prototype, "handleChange", null);
__decorate([
    autobind
], RichText.prototype, "handleRichTextBlur", null);
RichText = __decorate([
    observer
], RichText);
export default RichText;
